/*---------------------------------------------------------------------------------------------
 *  Copyright (c) by Solusek Systems. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import Globals from "../../shared/Globals";
import { qreq } from "../../shared/qrequest";
import L from "../Lang"
import BaseCom from "../BaseCom";
import Card from "../Card";
import Icon from "../Icon";
import RequestFormSendModal from "./RequestFormSendModal";
import { Pop } from "../PopModal";
import { withParamsAndNavigate } from "../WithParamsAndNavigate";
import RequestFormCreateModal from "./RequestFormCreateModal";
import Auth from "../../shared/Auth";

class RequestFormList extends BaseCom {
    constructor(props) {
        super(props);
        this.state = {
            showSendRequestForm: false
        };
        this.load = this.load.bind(this);
        this.delete = this.delete.bind(this);
    }

    componentDidMount() {
        this.load();
    }

    componentDidUpdate(prevProps) {
        if (this.props.item !== prevProps.item && this.props.item?.id !== prevProps.item?.id)
            this.load();
    }

    load() {
        if (this.props.item && this.props.item.id) {
            qreq.get('/api/form/list?orderID=' + this.props.item.id, j => {
                if (j.list)
                    this.setState({ list: j.list });
            });
        }
    }

    delete(item) {
        Pop.showConfirm(<><L>Are you sure you want to delete form sent on</L><br /><strong>{Globals.toMDYHMLocalDateString(item.sentDate)}</strong><L>?</L></>, 'Delete Form', () => {
            qreq.post('/api/form/delete', { id: item.id }, j => {
                if (j.errorCode === 0) {
                    this.success('The form has been deleted.');
                    var list = this.state.list.filter(i => i.id !== item.id);
                    this.setState({ list: list });
                }
                else
                    this.alert(j.errorMessage);
            }, this.unkownErrorCallback);
        });
    }

    render() {
        return <>
            <h1><L>Request Forms</L></h1>
            <RequestFormSendModal orderID={this.props.item?.id} emails={this.props.item?.referrer?.email} show={this.state.showSendRequestForm} onHide={() => { this.setState({ showSendRequestForm: false }); this.load(); }} />
            <RequestFormCreateModal orderID={this.props.item?.id} show={this.state.showCreateRequestForm} onHide={() => { this.setState({ showCreateRequestForm: false }); this.load(); }} />
            <Card title="Request Forms">
                {!Auth.hasRole('readonly') && <div className="d-flex justify-content-start align-items-center gap-1">
                    <button type="button" className="btn btn-primary" onClick={() => this.setState({ showSendRequestForm: true })}>Send Form Fill Request</button>
                    <button type="button" className="btn btn-secondary" onClick={() => this.setState({ showCreateRequestForm: true })}>Create Form Fill Request to Sign On-Site</button>
                </div>}
                <p><L>You will be asked for recipients on the next screen.</L></p>
                {this.state.list ? <table className="table table-striped">
                    <thead>
                        <tr>
                            <th></th>
                            <th><L>Form</L></th>
                            <th><L>Sent</L></th>
                            <th className="d-none d-md-table-cell"><L>Recipients</L></th>
                            <th className="d-none d-md-table-cell"><L>Completed</L></th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        {this.state.list.map((item, i) => <tr key={i}>
                            <td><a title="PDF" href={Globals.serverUrl + '/api/form/render/' + item.id + '/' + this.props.item?.patient?.fullName?.replace(/[^a-zA-Z0-9]+/, '-') + '-' + item.requestFormName?.replace(/[^a-zA-Z0-9]+/, '-') + '-' + item.name?.replace(/[^a-zA-Z0-9]+/, '-') + '.pdf'} target="_blank" rel="noreferrer"><Icon icon="faFilePdf" /></a></td>
                            <td><a title="PDF" href={Globals.serverUrl + '/api/form/render/' + item.id + '/' + this.props.item?.patient?.fullName?.replace(/[^a-zA-Z0-9]+/, '-') + '-' + item.requestFormName?.replace(/[^a-zA-Z0-9]+/, '-') + '-' + item.name?.replace(/[^a-zA-Z0-9]+/, '-') + '.pdf'} target="_blank" rel="noreferrer">{Globals.toMDYHMLocalDateString(item.sentDate)}</a></td>
                            <td>{item.requestFormName}</td>
                            <td className="d-none d-md-table-cell">{item.emails}{item.phone ? ', ' + item.phone : ''}</td>
                            <td className="d-none d-md-table-cell">{item.isFilled ? item.filledDate : 'No'}</td>
                            <td>{!Auth.hasRole('readonly') && !item.isFilled ? <span role="button" className="text-danger" title="Delete" onClick={() => this.delete(item)}><Icon icon="faTrash" /></span> : null}</td>
                        </tr>)}
                    </tbody>
                </table> : <p className="fs-italic"><L>No forms have been sent yet.</L></p>}
            </Card>
        </>;
    }
}

export default withParamsAndNavigate(RequestFormList);